{
    "name": "epicenter-portal",
    "version": "19.2.80136",
    "license": "MIT",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.2.8",
        "@angular/cdk": "^19.2.11",
        "@angular/common": "^19.2.8",
        "@angular/compiler": "^19.2.8",
        "@angular/core": "^19.2.8",
        "@angular/forms": "^19.2.8",
        "@angular/localize": "^19.2.8",
        "@angular/material": "^19.2.11",
        "@angular/platform-browser": "^19.2.8",
        "@angular/platform-browser-dynamic": "^19.2.8",
        "@angular/platform-server": "^19.2.8",
        "@angular/router": "^19.2.8",
        "@azure/msal-angular": "^3.0.9",
        "@azure/msal-browser": "^3.6.0",
        "@microsoft/microsoft-graph-client": "^2.0.0",
        "@popperjs/core": "^2.11.6",
        "@progress/kendo-angular-buttons": "^19.3.0",
        "@progress/kendo-angular-common": "^19.3.0",
        "@progress/kendo-angular-dateinputs": "^19.3.0",
        "@progress/kendo-angular-dialog": "^19.3.0",
        "@progress/kendo-angular-dropdowns": "^19.3.0",
        "@progress/kendo-angular-excel-export": "^19.3.0",
        "@progress/kendo-angular-gauges": "^19.3.0",
        "@progress/kendo-angular-grid": "^19.3.0",
        "@progress/kendo-angular-icons": "^19.3.0",
        "@progress/kendo-angular-indicators": "^19.3.0",
        "@progress/kendo-angular-inputs": "^19.3.0",
        "@progress/kendo-angular-intl": "^19.3.0",
        "@progress/kendo-angular-l10n": "^19.3.0",
        "@progress/kendo-angular-label": "^19.3.0",
        "@progress/kendo-angular-layout": "^19.3.0",
        "@progress/kendo-angular-menu": "^19.3.0",
        "@progress/kendo-angular-navigation": "^19.3.0",
        "@progress/kendo-angular-pager": "^19.3.0",
        "@progress/kendo-angular-pdf-export": "^19.3.0",
        "@progress/kendo-angular-pdfviewer": "^19.3.0",
        "@progress/kendo-angular-popup": "^19.3.0",
        "@progress/kendo-angular-progressbar": "^19.3.0",
        "@progress/kendo-angular-toolbar": "^19.3.0",
        "@progress/kendo-angular-treeview": "^19.3.0",
        "@progress/kendo-data-query": "^1.7.0",
        "@progress/kendo-drawing": "^1.19.0",
        "@progress/kendo-licensing": "^1.3.5",
        "@progress/kendo-theme-default": "^7.0.2",
        "@progress/telerik-angular-report-viewer": "^21.24.305",
        "adal-angular": "^1.0.17",
        "ajv": "^6.12.6",
        "async": "^2.5.0",
        "babel-loader": "^8.2.5",
        "bingmaps": "^2.0.3",
        "bootstrap": "^5.2.3",
        "core-js": "^3.27.2",
        "css": "^2.2.4",
        "es6-shim": "0.35.3",
        "event-source-polyfill": "0.0.9",
        "expose-loader": "^4.0.0",
        "font-awesome": "^4.6.3",
        "increase-memory-limit": "^1.0.6",
        "isomorphic-fetch": "^3.0.0",
        "jquery": "3.7",
        "json-loader": "^0.5.4",
        "libphonenumber-js": "^1.12.33",
        "ngx-toastr": "^19.0.0",
        "ol": "^6.2.1",
        "pdfjs-dist": "^4.6.82",
        "preboot": "4.5.2",
        "reflect-metadata": "0.1.10",
        "rxjs": "^7.8.1",
        "tar": "^6.1.13",
        "tslib": "^2.3.0",
        "xlsx": "^0.18.5",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.2.9",
        "@angular/cli": "^19.2.9",
        "@angular/compiler-cli": "^19.2.8",
        "@angular/language-service": "^19.2.8",
        "@ngtools/webpack": "^19.2.9",
        "@types/adal-angular": "^1.0.1",
        "@types/chai": "4.0.1",
        "@types/jasmine": "~3.8.0",
        "@types/jasminewd2": "~2.0.2",
        "@types/node": "~6.0.60",
        "@types/webpack-env": "^1.18.0",
        "angular2-template-loader": "^0.6.2",
        "aspnet-prerendering": "^3.0.1",
        "chai": "4.0.2",
        "circular-dependency-plugin": "^5.2.0",
        "clean-webpack-plugin": "^4.0.0",
        "copy-webpack-plugin": "^11.0.0",
        "css-loader": "^5.2.6",
        "file-loader": "^6.2.0",
        "html-loader": "^1.3.2",
        "html-webpack-plugin": "^5.5.0",
        "jasmine-core": "~3.8.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "^6.4.1",
        "karma-chai": "0.1.0",
        "karma-chrome-launcher": "~3.1.0",
        "karma-cli": "^2.0.0",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.5.4",
        "karma-webpack": "^5.0.0",
        "raw-loader": "^4.0.2",
        "sass": "^1.35.1",
        "sass-loader": "^10.4.1",
        "source-map-loader": "^1.1.3",
        "style-loader": "^2.0.0",
        "to-string-loader": "^1.2.0",
        "ts-loader": "^9.4.2",
        "ts-node": "^10.7.0",
        "typescript": "5.5.4",
        "url-loader": "^3.0.0",
        "webpack": "^5.75.0",
        "webpack-cli": "^4.10.0",
        "webpack-dev-middleware": "^3.0.0",
        "webpack-hot-middleware": "^2.25.2",
        "webpack-merge": "^5.8.0"
    }
}
